import { useState, useEffect, useMemo } from 'react';
import { appCfgApi } from '../../../services/api';

const CATEGORY_LOOKUP = 'Theme_Category';

/**
 * Themes grouped by category: the Theme_Category lookup order first, then any category no
 * longer in the lookup (alphabetical), then Uncategorized. Within a group the API's order
 * (SortOrder, then Label) holds. Also returns the active category vocabulary.
 */
const useThemeGroups = (themes) => {
  const [categories, setCategories] = useState([]);

  // Lookup Values rows, so adding a category needs no code change.
  useEffect(() => {
    let live = true;
    appCfgApi.getLookupsByCategory(CATEGORY_LOOKUP)
      .then(res => {
        if (!live) return;
        const rows = (res.data || []).filter(r => r.is_Active !== false);
        rows.sort((a, b) => (a.display_Order ?? 0) - (b.display_Order ?? 0));
        setCategories(rows.map(r => r.value));
      })
      .catch(() => { /* no vocabulary: themes still list, as Uncategorized */ });
    return () => { live = false; };
  }, []);

  const groups = useMemo(() => {
    const byCat = new Map();
    (themes || []).forEach(t => {
      const c = t.category || '';
      if (!byCat.has(c)) byCat.set(c, []);
      byCat.get(c).push(t);
    });
    const order = [...categories, ...[...byCat.keys()].filter(c => c && !categories.includes(c)).sort(), ''];
    return order.filter(c => byCat.has(c)).map(c => ({ category: c || 'Uncategorized', themes: byCat.get(c) }));
  }, [themes, categories]);

  return { groups, categories };
};

export default useThemeGroups;
